import React from 'react';

import Default from '@common/blocks/flex/Default';
import FloatingIcons from '@common/blocks/flex/floating-icons/FloatingIcons';
import BackgroundImage from '@common/blocks/flex/background-image/BackgroundImage';
import BackgroundImages from '@common/blocks/flex/background-images/BackgroundImages';
import ImageButtons from '@common/blocks/flex/image-buttons/ImageButtons';
import NameGenerator from '@common/blocks/flex/name-generator/NameGenerator';
import DropShadow from '@common/blocks/flex/drop-shadow/DropShadow';
import ImageQuotes from '@common/blocks/flex/image-quotes/ImageQuotes';
import FilterCustomerStories from '@common/blocks/flex/filter-customer-stories/FilterCustomerStories';
import DropdownSearch from '@common/blocks/flex/dropdown-search/DropdownSearch';
import StarRating from '@common/blocks/flex/star-rating/StarRating';
import HomepageVideo from '@common/blocks/flex/homepage-video/HomepageVideo';
import HomepageImageBothSides from '@common/blocks/flex/homepage-image-both-sides/HomepageImageBothSides';
import HomepageQuiz from '@common/blocks/flex/homepage-quiz/HomepageQuiz';
import BorderedList from '@common/blocks/flex/bordered-list/BorderedList';
import CoreValuesGrid from '@common/blocks/flex/core-values-grid/CoreValuesGrid';
import DownloadEbook from '@common/blocks/flex/download-ebook/DownloadEbook';
import EmailSignup from '@common/blocks/flex/email-signup/EmailSignup';
import RotatingText from '@common/blocks/flex/rotating-text/RotatingText';
import ProductAddOn from '@common/blocks/flex/product-add-on/ProductAddOn';
import HeroGradient from '@common/blocks/flex/hero-gradient/HeroGradient';
import TextWithLinkSlider from '@common/blocks/flex/text-with-link-slider/TextWithLinkSlider';
import UserSignature from '@common/blocks/flex/user-signature/UserSignature';
import ButtonBelowContainer from '@common/blocks/flex/button-below-container/ButtonBelowContainer';
import FullWidthVideo from '@common/blocks/flex/full-width-video/FullWidthVideo';
import FullWidthVideoQuiz from '@common/blocks/flex/full-width-video-quiz/FullWidthVideoQuiz';
import MidBgWhite from '@common/blocks/flex/mid-bg-white/MidBgWhite';
import LargeButton from '@common/blocks/flex/large-button/LargeButton';
import SummitAgenda from '@common/blocks/flex/summit-agenda/SummitAgenda';
import SummitSignUpBanner from '@common/blocks/flex/summit-sign-up-banner/SummitSignUpBanner';

const components = [
  {
    component: Default,
    key: 'Default'
  },
  {
    component: FloatingIcons,
    key: 'Floating Icons'
  },
  {
    component: BackgroundImage,
    key: 'Background Image'
  },
  {
    component: BackgroundImages,
    key: 'Background Images'
  },
  {
    component: ImageButtons,
    key: 'Image Buttons'
  },
  {
    component: NameGenerator,
    key: 'Name Generator'
  },
  {
    component: DropShadow,
    key: 'Drop Shadow'
  },
  {
    component: ImageQuotes,
    key: 'Image Quotes'
  },
  {
    component: FilterCustomerStories,
    key: 'Filter Customer Stories'
  },
  {
    component: DropdownSearch,
    key: 'Dropdown Search'
  },
  {
    component: StarRating,
    key: 'Star Rating'
  },
  {
    component: HomepageVideo,
    key: 'Homepage - Video'
  },
  {
    component: HomepageImageBothSides,
    key: 'Homepage - Image on both sides'
  },
  {
    component: HomepageQuiz,
    key: 'Homepage - Quiz'
  },
  {
    component: BorderedList,
    key: 'Bordered List'
  },
  {
    component: CoreValuesGrid,
    key: 'Core Values Grid'
  },
  {
    component: DownloadEbook,
    key: 'Download E-Book'
  },
  {
    component: EmailSignup,
    key: 'E-mail Signup'
  },
  {
    component: RotatingText,
    key: 'Rotating Text'
  },
  {
    component: ProductAddOn,
    key: 'Product Add On'
  },
  {
    component: HeroGradient,
    key: 'Hero Gradient'
  },
  {
    component: TextWithLinkSlider,
    key: 'Text with Link Slider'
  },
  {
    component: UserSignature,
    key: 'User Signature'
  },
  {
    component: ButtonBelowContainer,
    key: 'Button Below Container'
  },
  {
    component: FullWidthVideo,
    key: 'Full Width Video'
  },
  ,
  {
    component: FullWidthVideoQuiz,
    key: 'Full Width Video Quiz'
  },
  {
    component: MidBgWhite,
    key: 'Mid Background White'
  },
  {
    component: LargeButton,
    key: 'Large Button'
  },
  {
    component: SummitAgenda,
    key: 'Summit - Agenda'
  },
  {
    component: SummitSignUpBanner,
    key: 'Summit - Sign up banner'
  }
];

const FlexBlock = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x?.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default FlexBlock
